<template>
    <router-view />
</template>

<script>
    import remPlan from '@/utils/rem';
    export default {
        name: 'App',
        computed: {
            showLang() {
                return this.$store.getters.showLang;
            },
            showThemeMode() {
                return this.$store.getters.showThemeMode;
            },
        },
        mounted() {
            this.preventIosZoom();
            this.$i18n.locale = this.showLang;
            window.addEventListener('resize', remPlan);
        },
        methods: {
            preventIosZoom() {
                let lastTouchEnd = 0;
                document.addEventListener('touchstart', function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault();
                    }
                });
                document.addEventListener(
                    'touchend',
                    function (event) {
                        const now = new Date().getTime();
                        if (now - lastTouchEnd <= 300) {
                            event.preventDefault();
                        }
                        lastTouchEnd = now;
                    },
                    false,
                );

                document.addEventListener('gesturestart', function (event) {
                    event.preventDefault();
                });
            },
        },
        watch: {
            showLang(v) {
                this.$i18n.locale = v;
            },
        },
    };
</script>

<style scoped></style>
